import { Observable } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IRun } from '../../core/model/runs/run';
import { delay, retryWhen } from 'rxjs/operators';
import { BsApiEndPoints } from '../../core/services/bs-api/endpoints';
import { genericRetryWhen, observableEmitDelay } from '../../core/rxjsutils/rxjs-utilities';
import { IUnzipRunResponse } from '@app/core/model/v2-api/v2-api-wrappers';

export interface IRunUnzipService {
  canUnzip(run: IRun, currentUserId: string): boolean;
  unzip (run: IRun): Observable<IUnzipRunResponse>
}

@Injectable({
  providedIn: 'root'
})
export class RunUnzipService implements IRunUnzipService {
  constructor( private httpClient: HttpClient){
  }

  /**
   * Checks whether the User is allowed to unzip resource or not
   * @param resource Resource to trash
   * @param currentUserId Id of the current user
   */
  canUnzip(run: IRun, currentUserId: string): boolean {
    if (isNullOrUndefined(run) || isNullOrUndefined(currentUserId)) {
      return false;
    }

    return this.isRunOwner(currentUserId, run) && run.IsZipped;
  }

  public unzip(run: IRun): Observable<IUnzipRunResponse> {
    const postData = { RunIds: [run.V1Pre3Id] };
    return this.httpClient.post<IUnzipRunResponse>(BsApiEndPoints.UNZIP_URL, postData).pipe(
      // Retry in case of HTTP errors
      retryWhen(genericRetryWhen()),
      // To avoid a Flash of content, maintain a delay
      delay(observableEmitDelay),
    );
    // return this.basespaceApi.UnzipRun({Id: null });
  }

  private isRunOwner(currentUserId: string, run: IRun) {
    return run.UserOwnedBy.Id === currentUserId;
  }
}
